import React from "react";
import { getSetting } from "../config.mjs";
function useDidHydrateOnceRoot() {
  return !0;
}
let last = Date.now();
function useDidHydrateOnce() {
  return getSetting("disableSSR") ? !0 : useDidHydrateSync();
}
const emptySubscribe = () => () => {},
  getClientSnapshot = () => !0,
  getServerSnapshot = () => !1,
  useDidHydrateSync = () => React.useSyncExternalStore(emptySubscribe, getClientSnapshot, getServerSnapshot);
export { useDidHydrateOnce, useDidHydrateOnceRoot };
//# sourceMappingURL=useDidHydrateOnce.mjs.map
